export const MARKETING_TRACKING_SESSION_STORAGE_KEY = 'marketing_tracking';

export const saveTrackingSearchParam = (search: string) => {
  sessionStorage.setItem(MARKETING_TRACKING_SESSION_STORAGE_KEY, search);
};

export function getURLWithUTMs(url: string) {
  const searchWithUTMs = sessionStorage.getItem(MARKETING_TRACKING_SESSION_STORAGE_KEY);
  if (!searchWithUTMs) return url;
  return `${url}${encodeURIComponent(searchWithUTMs)}`;
}
